// extracted by mini-css-extract-plugin
export default {"SayHello":"SayHello-module-d1fc1a904eb1f827206f"};